import { render, staticRenderFns } from "./ApiDocsPage.vue?vue&type=template&id=4ec942ee&"
import script from "./ApiDocsPage.vue?vue&type=script&lang=js&"
export * from "./ApiDocsPage.vue?vue&type=script&lang=js&"
import style0 from "./ApiDocsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports